var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chart-container-stake-allocate"},[_c('ChartPie',{staticClass:"chart",attrs:{"chartdata":_vm.chartdata,"options":_vm.options,"width":200,"height":200},on:{"generated":_vm.setLegend}}),_c('div',{staticClass:"legend-container",attrs:{"id":"legend-container"},domProps:{"innerHTML":_vm._s(_vm.legend)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }